import { StandardComponent } from "@/types/types";
import * as components from "./index";

export const componentMap: { [name: string]: StandardComponent } = components;
